import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    IconButton,
    Button
} from "@mui/material"
import { HighlightOff } from "@mui/icons-material"
import CreatorToUserInvoice from "../../../../../components/invoice-template/creator-to-user-ticket-purchase-invoice/CreatorToUserInvoice"
import ShmoozToUserInvoice from "../../../../../components/invoice-template/shmooz-to-user-tax-invoice/ShmoozToUserInvoice"
import PurchaseTicket from "../../../../../components/UiComponent/PurchaseTicket"
import ShmoozToCreatorInvoice from "../../../../../components/invoice-template/shmooz-to-creator-invoice/ShmoozToCreatorInvoice"
import { H4 } from "../../../../../themes/typography"

export default function InvoicesModal({
    onClose = () => { },
    onDownload = () => { },
    open = true,
    modalType = 'creatorToUserInvoice' // 'creatorToUserInvoice' | 'shmoozToUserInvoice' | 'purchaseTicket'
}) {
    return (
        <Dialog
            open={open}
            sx={{
                '& .MuiPaper-root': {
                    background: 'var(--gradient-blue)',
                    color: 'var(--quaternary-color)',
                    borderRadius: '1rem',
                    border: '1px solid var(--divider-color)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.5rem',
                    padding: '1rem',
                    maxWidth: 'fit-content',
                    minWidth: '900px',
                    maxHeight: 'calc(100% - 40px)'
                }
            }}
            slotProps={{
                backdrop: {
                    sx: {
                        backdropFilter: 'blur(3px)',
                    }
                }
            }}
        >
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: '0.5rem',
                    padding: '0rem',
                }}
            >
                <div className="event-review-title">
                    <H4 fontWeight={600}>
                        Tax Invoice
                    </H4>
                </div>

                <IconButton
                    onClick={onClose}
                >
                    <HighlightOff color="secondary" />
                </IconButton>
            </DialogTitle>

            <DialogContent
                dividers={true}
                sx={{
                    borderTop: '1px solid var(--divider-color)',
                    borderBottom: '1px solid var(--divider-color)',
                    padding: '0rem',
                    backgroundColor: 'var(--gradient-overlay-bg-color)',
                }}
            >
                {modalType === 'creatorToUserInvoice' && (
                    <CreatorToUserInvoice />
                    // <ShmoozToCreatorInvoice />
                )}

                {modalType === 'shmoozToUserInvoice' && (
                    <ShmoozToUserInvoice />
                )}

                {modalType === 'purchaseTicket' && (
                    <PurchaseTicket />
                )}
            </DialogContent>

            <DialogActions
                sx={{
                    padding: '0'
                }}
            >
                <Button
                    variant="textSm"
                    onClick={onClose}
                >
                    Cancel
                </Button>

                <Button
                    variant="mainSm"
                    onClick={onDownload}
                >
                    Download
                </Button>
            </DialogActions>
        </Dialog>
    )
}